import { Button } from '@studio/design-system/button';
import { Icon } from '@studio/design-system/icon';
import { usePrompt } from '@studio/design-system/prompt';
import * as Select from '@studio/design-system/select';
import { useCallback, useState } from 'react';
import { post } from '../../../notifications/index.js';
import { RoundedProfile } from './components.jsx';

/** InviteByLink component. */
export const InviteByLink = () => {
  const [linkCreated, setLinkCreated] = useState(false);
  const prompt = usePrompt();
  const [value, setValue] = useState('viewer');

  const copyLink = useCallback(() => {
    void navigator.clipboard
      .writeText('https://google.com')
      .then(() => {
        post({
          title: 'Link Copied to your clipboard',
          message: 'Share link to invite users to your studio.',
          severity: 'success'
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div className='flex items-center'>
      <div className='flex grow items-center justify-center gap-x-12'>
        <RoundedProfile className='drop-shadow-sm'>
          <Icon className='-rotate-45 text-lg' icon='link' />
        </RoundedProfile>
        {linkCreated ? (
          <div className='flex flex-col gap-4'>
            <div>Anyone with this link</div>
            <button
              className='inline text-left text-primary underline'
              onClick={copyLink}
              type='button'
            >
              Copy link
            </button>
          </div>
        ) : (
          <span>Invite users with a link</span>
        )}
        {linkCreated ? (
          <div className='w-auto shrink'>
            <Select.Root
              onValueChange={(v) => {
                if (v === 'delete') {
                  prompt.confirm({
                    title: 'Delete invite link',
                    message: 'Are you sure you want to delete the invite link?',
                    onConfirm: (answer) => {
                      if (answer) {
                        setLinkCreated(false);
                      }
                    }
                  });
                } else {
                  setValue(v);
                }
              }}
              value={value}
              variant='light'
            >
              <Select.Trigger className='bg-transparent'>
                <Select.Value />
              </Select.Trigger>
              <Select.Content align='end' position='popper' side='bottom'>
                <Select.Item value='viewer'>Can join as a Viewer</Select.Item>
                <Select.Item value='producer'>Can join as Producer</Select.Item>
                <Select.Item value='admin'>Can join as Admin</Select.Item>
                <Select.Item className='h-auto px-0 text-error hover:text-white' value='delete'>
                  <div className='flex flex-col gap-4 px-12 py-8'>
                    <div>Delete this link</div>
                    <div className='text-muted'>The existing link will no more work. </div>
                  </div>
                </Select.Item>
              </Select.Content>
            </Select.Root>
          </div>
        ) : (
          <Button
            className='m-8 border-primary text-primary'
            onClick={(): void => {
              setLinkCreated(true);
            }}
            size='lg'
            variant='secondary'
          >
            Create Link
          </Button>
        )}
      </div>
    </div>
  );
};
